var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.7329V9.26621C1.6665 8.39954 2.37484 7.68287 3.24984 7.68287C4.75817 7.68287 5.37484 6.61621 4.6165 5.30787C4.18317 4.55787 4.4415 3.58287 5.19984 3.14954L6.6415 2.32454C7.29984 1.93287 8.14984 2.16621 8.5415 2.82454L8.63317 2.98287C9.38317 4.29121 10.6165 4.29121 11.3748 2.98287L11.4665 2.82454C11.8582 2.16621 12.7082 1.93287 13.3665 2.32454L14.8082 3.14954C15.5665 3.58287 15.8248 4.55787 15.3915 5.30787C14.6332 6.61621 15.2498 7.68287 16.7582 7.68287C17.6248 7.68287 18.3415 8.39121 18.3415 9.26621V10.7329C18.3415 11.5995 17.6332 12.3162 16.7582 12.3162C15.2498 12.3162 14.6332 13.3829 15.3915 14.6912C15.8248 15.4495 15.5665 16.4162 14.8082 16.8495L13.3665 17.6745C12.7082 18.0662 11.8582 17.8329 11.4665 17.1745L11.3748 17.0162C10.6248 15.7079 9.3915 15.7079 8.63317 17.0162L8.5415 17.1745C8.14984 17.8329 7.29984 18.0662 6.6415 17.6745L5.19984 16.8495C4.4415 16.4162 4.18317 15.4412 4.6165 14.6912C5.37484 13.3829 4.75817 12.3162 3.24984 12.3162C2.37484 12.3162 1.6665 11.5995 1.6665 10.7329Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingWhite);
export default __webpack_public_path__ + "static/media/settingWhite.e11aa67cc1a02532ccf8dbe988297c7f.svg";
export { ForwardRef as ReactComponent };